// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3igs0","subheader":"ReorderModal_subheader__30n1N","listWrap":"ReorderModal_listWrap__3uwLh"};